import { render, staticRenderFns } from "./order-transfer.vue?vue&type=template&id=6589901a&scoped=true"
import script from "./order-transfer.vue?vue&type=script&lang=js"
export * from "./order-transfer.vue?vue&type=script&lang=js"
import style0 from "./order-transfer.vue?vue&type=style&index=0&id=6589901a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589901a",
  null
  
)

export default component.exports